var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('v-row',[_c('v-col',[_c('h3',[_vm._v("Нажмите на кнопку ниже, чтобы выйти из системы")]),_c('v-btn',{attrs:{"color":"lightblue"},on:{"click":_vm.logout}},[_vm._v("Выйти")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }